import * as React from "react"

import Paragraph from "../../../../design-system/paragraph"
import * as styles from "./index.module.scss"

const FooterCopyright = () => (
  <Paragraph
    data-chromatic="ignore"
    className={styles.footerCopyright}
    variant="3"
  >
    ©{new Date().getFullYear()} Tremendous
  </Paragraph>
)

export default FooterCopyright
